module.exports = __webpack_public_path__ + "static/harrisons-carpet-flooring-4981b83ec3bc9f8a1c93ef7b4909d6f4.webp";